import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["filtersContainer", "template", "wildcardInfo"];
  static values = {
    index: Number,
    filterWildcardSupportOperators: Array,
    filterOperatorPlaceholders: Object,
  };

  connect() {
    this.updateLabels();
  }

  addFilter(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.indexValue);
    this.filtersContainerTarget.insertAdjacentHTML("beforeend", content);
    this.indexValue++;
    this.updateLabels();
  }

  removeFilter(event) {
    event.preventDefault();

    const filterItem = event.target.closest(".filter-item");
    const destroyInput = filterItem.querySelector('input[name*="[_destroy]"]');

    if (destroyInput) {
      // Mark existing filter for destruction
      destroyInput.value = "1";
      filterItem.style.display = "none";
    } else {
      // Remove new filter from DOM
      filterItem.remove();
    }

    this.updateLabels();
  }

  updateLabels() {
    const visibleFilters = Array.from(
      this.filtersContainerTarget.querySelectorAll(".filter-item")
    ).filter((filter) => filter.style.display !== "none");

    visibleFilters.forEach((filter, index) => {
      const labels = filter.querySelectorAll("label");

      if (index === 0) {
        // Show labels for first filter
        labels.forEach((label) => {
          label.style.display = "";
        });
      } else {
        // Hide labels for subsequent filters
        labels.forEach((label) => {
          if (!label.textContent.trim() || label.textContent.trim() === "\u00A0") {
            return; // Skip empty labels
          }
          label.style.display = "none";
        });
      }
    });
  }

  changeOperator(event) {
    const operatorSelect = event.target;
    const filterItem = operatorSelect.closest(".filter-item");
    const valueInput = filterItem.querySelector(".value-input");
    const wildcardInfo = filterItem.querySelector(".wildcard-info");

    if (!valueInput) {
      return;
    }

    const operator = operatorSelect.value;

    // Update placeholder based on specific operator
    const placeholder = this.filterOperatorPlaceholdersValue[operator];
    if (placeholder) {
      valueInput.placeholder = placeholder;
    }

    // Show/hide wildcard info based on operator
    if (wildcardInfo) {
      const supportsWildcards = this.filterWildcardSupportOperatorsValue.includes(operator);
      if (supportsWildcards) {
        wildcardInfo.classList.remove("hidden");
      } else {
        wildcardInfo.classList.add("hidden");
      }
    }
  }
}
